import { SOFT_FAIL_BROWSER_TOOLS } from "./soft-fail-browser-tools-constants";

/** Anchored at the START: a snapshot of a page reading "login failed" is a
 * successful read, and a loose match would paint it as an error. */
export function softFailedBrowser(toolName: string, output: unknown): boolean {
  return (
    SOFT_FAIL_BROWSER_TOOLS.has(toolName) &&
    typeof output === "string" &&
    /^(?:browser|repl)_[a-z_]+ failed:/.test(output.trimStart())
  );
}
